import { FC, PropsWithChildren, useEffect } from "react";
import useEvent from "react-use-event-hook";

import { DrawerType, Log } from "@ryde/shared";

import { MobileFiltersDrawerReports } from "./mobile-filters.drawer.reports";

interface IPageHeadersFiltersMobileSidebarReports extends PropsWithChildren {
  mainTitle: string;
  onApply: () => void;
  setIsFilterSidebarOpen: (value: boolean) => void;
}

export const PageHeadersFiltersMobileSidebarReports: FC<
  IPageHeadersFiltersMobileSidebarReports
> = ({ setIsFilterSidebarOpen, mainTitle, onApply, children }) => {
  const resetFilterValues = useEvent((): void => {
    Log.debug(`Cleanup map data`);
  });
  useEffect(() => {
    return () => resetFilterValues();
  }, [resetFilterValues]);

  const closeSidebar = useEvent((): void => {
    setIsFilterSidebarOpen(false);
  });

  return (
    <MobileFiltersDrawerReports
      title={mainTitle}
      onCloseDrawer={closeSidebar}
      type={DrawerType.EditForm}
    >
      {children}
    </MobileFiltersDrawerReports>
  );
};
